import { useQuery } from '@tanstack/react-query'

import { getQueryClient, QueryKey } from 'shared/api'

import {
  getRewardsProgramData,
  GetRewardsProgramDataResponse
} from '../api'

const staleTime = 1000 * 60 * 30 // 30 minutes

export const useQueryRewardsProgram = () => {
  return useQuery({
    queryKey: [QueryKey.rewardsProgram],
    queryFn: async () => {
      const response = await getRewardsProgramData()

      return response
    },
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    staleTime
  })
}

export const queryFetchRewardsProgram = async () => {
  return await getQueryClient().fetchQuery<GetRewardsProgramDataResponse>({
    queryKey: [QueryKey.rewardsProgram],
    queryFn: () => getRewardsProgramData(),
    staleTime
  })
}
